import { render, staticRenderFns } from "./AssessmentCardSkeleton.vue?vue&type=template&id=c81bc634&scoped=true"
import script from "./AssessmentCardSkeleton.vue?vue&type=script&lang=js"
export * from "./AssessmentCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCardSkeleton.vue?vue&type=style&index=0&id=c81bc634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81bc634",
  null
  
)

export default component.exports